import React, { useState } from 'react';
import { Box, Skeleton } from '@mui/material';
import { API_BASE_URL } from '../config/api';

const SimpleImage = ({ 
  src, 
  alt, 
  sx = {},
  aspectRatio = '1',
  showSkeleton = true,
  ...props 
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);

  // Simple image URL - use products.php directly without resizing
  const getSimpleUrl = (originalUrl) => {
    if (!originalUrl || originalUrl === '/placeholder-image.jpg') {
      return originalUrl;
    }

    // For external URLs, return as-is
    if (originalUrl.startsWith('http') && !originalUrl.includes(API_BASE_URL)) {
      return originalUrl;
    }

    // For local images, use direct path from products.php
    // This assumes images are served directly from the uploads directory
    let imagePath = originalUrl;
    
    // Remove API_BASE_URL if present
    if (imagePath.startsWith(API_BASE_URL)) {
      imagePath = imagePath.replace(API_BASE_URL + '/', '');
    }
    
    // Remove leading slash if present
    if (imagePath.startsWith('/')) {
      imagePath = imagePath.substring(1);
    }

    // Return direct image path (as provided by products.php)
    return `${API_BASE_URL}/${imagePath}`;
  };

  const handleLoad = () => setIsLoaded(true);
  const handleError = () => {
    setError(true);
    setIsLoaded(true);
  };

  const imageUrl = getSimpleUrl(src);

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        aspectRatio,
        backgroundColor: '#f5f5f5',
        ...sx
      }}
      {...props}
    >
      {showSkeleton && !isLoaded && (
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{ 
            position: 'absolute', 
            top: 0, 
            left: 0,
            aspectRatio
          }}
          animation="wave"
        />
      )}
      <Box
        component="img"
        src={error ? '/placeholder-image.jpg' : imageUrl}
        alt={alt}
        onLoad={handleLoad}
        onError={handleError}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          opacity: isLoaded ? 1 : 0,
          transition: 'opacity 0.3s ease',
          position: 'absolute',
          top: 0,
          left: 0
        }}
      />
    </Box>
  );
};

export default SimpleImage;
